import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        VDialog,
        {
          attrs: { width: _vm.width, persistent: true, scrollable: "" },
          model: {
            value: _vm.isOpen,
            callback: function ($$v) {
              _vm.isOpen = $$v
            },
            expression: "isOpen",
          },
        },
        [
          _c(
            VCard,
            { staticStyle: { "max-height": "500px" } },
            [
              _c(
                VCardTitle,
                {
                  staticClass: "justify-center",
                  attrs: { "primary-title": "" },
                },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "close",
                      staticStyle: {
                        position: "absolute",
                        right: "15px",
                        top: "15px",
                      },
                      attrs: { icon: "" },
                      on: { click: _vm.onClose },
                    },
                    [_c(VIcon, [_vm._v("icon-decline")])],
                    1
                  ),
                  _vm.custom_title
                    ? _vm._t("title")
                    : [_vm._v(_vm._s(_vm.title))],
                ],
                2
              ),
              _vm.isOpen
                ? _c(
                    VCardText,
                    {
                      staticClass: "pb-0 pl-3 pr-3 text-center",
                      attrs: { align: "center" },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "table", margin: "0 auto" } },
                        [
                          _c(VImg, {
                            attrs: {
                              "max-width": "200px",
                              src: require("@/assets/token_img.png"),
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", [
                        _vm._v(
                          "Por favor ingrese el token de 4 dígitos que le llegará a su correo " +
                            _vm._s(_vm.userInfo.email)
                        ),
                      ]),
                      _c(
                        VRow,
                        { staticClass: "pt-4 justify-center" },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                VContainer,
                                { staticClass: "pa-0" },
                                [
                                  _c(
                                    VSheet,
                                    { staticClass: "token-input" },
                                    _vm._l(4, function (index) {
                                      return _c(VTextField, {
                                        key: index,
                                        ref: "tokenFields",
                                        refInFor: true,
                                        staticClass: "token-field",
                                        attrs: {
                                          "hide-details": "",
                                          maxlength: "1",
                                          inputmode: "numeric",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.moveFocus($event, index)
                                          },
                                        },
                                        model: {
                                          value: _vm.tokens[index - 1],
                                          callback: function ($$v) {
                                            _vm.$set(_vm.tokens, index - 1, $$v)
                                          },
                                          expression: "tokens[index-1]",
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(VDivider),
              _vm.showButtons
                ? _c(
                    VCardActions,
                    { staticClass: "pt-1 pl-3 pr-3 pb-3 justify-center" },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "primary",
                          attrs: { text: "", outlined: "", color: "white" },
                          on: {
                            click: function ($event) {
                              return _vm.onSend()
                            },
                          },
                        },
                        [
                          _c(
                            VIcon,
                            { attrs: { color: "white", small: "" } },
                            [_vm._v("mdi-check-circle-outline")]
                          ),
                          _vm._v("Validar"),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }